export { EventDetails } from './EventDetails';
export type { EventDetailsProps } from './EventDetails';
